export default __webpack_public_path__ + "static/media/gnu.15045225.svg";